import { useWallet } from "@/hooks/useWallet";
import { DashboardView } from "@/components/dashboard/DashboardView";

export default function PerpsPerformance() {
  const { address } = useWallet();

  if (!address) return null;

  return <DashboardView address={address} marketType="perps" />;
}
